import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { STORE_COMPONENTS } from '@/lib/constants';
import { DropdownPicker, DataItem } from '../dropdown-picker';

export const DropdownDepartment: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();
  const components = [...STORE_COMPONENTS];
  const departments: DataItem[] = [];

  components
    .filter((c) => c.departments.length > 0)
    .map((c) => c.departments)
    .forEach((departmentArray) =>
      departmentArray.forEach((d) =>
        departments.push({
          value: d.value,
          text: t(`label.components.departments.${d.value}`),
        })
      )
    );

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.department')}
      data={departments}
      control="checkbox"
      search
    />
  );
};
